import { all, call, put, takeLatest } from 'redux-saga/effects';
import { activePlansFailure, activePlansSuccess, compatibilitySuccess, compatibilityFailure, reservePromoCouponSuccess, reservePromoCouponFailure } from './actions';
import { ACTIVE_PLANS, COMPATIBILITY, RESERVE_PROMO_COUPON } from './actionTypes';
import apiJunction from '../../utils/api';
import { version } from '../../config';
import ApiEndPoints from '../../utils/ApiEndPoints';

export interface ResponseGenerator {
    config?: any;
    data?: any;
    headers?: any;
    request?: any;
    status?: number;
    statusText?: string;
}

function* activePlans(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `/catalogsvc/${version}/plans/data?countryCode=${action.payload.countryCode}`,
        });
        yield put(
            activePlansSuccess({
                plans: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            activePlansFailure({
                error: e.message,
            }),
        );
    }
}

function* compatibility(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints.compatibility}/${action.payload.imeiNumber}`,
        });
        yield put(
            compatibilitySuccess({
                compat: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            compatibilityFailure({
                errorCompat: e.message,
            }),
        );
    }
}

function* reservePromoCoupon(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `/catalogsvc/${version}/coupon/email/mapping`,
            body: action.payload.data,
        });
        yield put(
            reservePromoCouponSuccess({
                data: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            reservePromoCouponFailure({
                errorData: e.message,
            }),
        );
    }
}

function* planSaga() {
    yield all([
        takeLatest(ACTIVE_PLANS, activePlans),
        takeLatest(COMPATIBILITY, compatibility),
        takeLatest(RESERVE_PROMO_COUPON, reservePromoCoupon)
    ]);
}

export default planSaga;
